import { requestLaravel } from "../../../../../utils/api";
import { ApiResponse } from "../../../core/_models";
import { IProjectTeam } from "../_models";

type IProjectTeamResponse = {
    list: IProjectTeam[];
};

export function getTeamMembersList(project_id: number, signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IProjectTeamResponse>>(
        "/projects/team-members/list",
        { project_id },
        { signal }
    );

}

export function addOrUpdateProjectTeam(inputData: {
    project_id: number;
    member_user_id: number;
    role_id: string;
    project_rights: string;
    old_role_id?: string;
}) {
    return requestLaravel<ApiResponse<IProjectTeam>>(
        "/projects/team-members/save",
        inputData
    );
}

export function deleteProjectTeam(inputData: {
    delete_id: number;
    project_id: number;
    role_id?: string;
}) {
    return requestLaravel<ApiResponse<{ delete_id: number; project_id: number; role_id?: string }>>(
        "/projects/team-members/delete",
        inputData
    );
}
